import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3fca137f&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=3fca137f&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fca137f')) {
      api.createRecord('3fca137f', component.options)
    } else {
      api.reload('3fca137f', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3fca137f&lang=pug", function () {
      api.rerender('3fca137f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/vip/upgradeTest/index.vue"
export default component.exports